import AppSimpleBar from "components/AppSimpleBar";
import classnames from "classnames";
import { Utils } from "helpers/utils";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { APIClient } from "../api/apiCore";
import * as urls from "../api/urls";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HelpInfo from "components/HelpInfo";
import BackHeaderIcon from "components/BackHeaderIcon";
import { setActiveTool } from "../redux/actions"


interface BackHeaderIconProps {
  titleText: string;
  titleIcon: string;
  titleHelp?: string[] | null;
  // capCol1: string;
  // capCol2: string;
  // componentHdr1: React.ReactNode;
  componentCol1: React.ReactNode;
  // componentCol2: React.ReactNode;
  // haveCol2Data: boolean;
  // editCol2Key: any;
  onSetEditCol2Key(key: any): void;
}


const MasterPage1Column = ({ titleText, titleIcon, titleHelp, /*capCol1, capCol2, componentHdr1,*/ componentCol1/*, componentCol2, editCol2Key*/, onSetEditCol2Key }: BackHeaderIconProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Layout,
    (layout) => ({
      viewPortSize: layout.viewPortSize,
    })
  );
  // Inside your component
  const {
    viewPortSize
  } = useAppSelector(storeData);

  const [showSecondCol, setShowSecondCol] = useState<boolean>(true);


  // useEffect(() => {
  //   console.log('haveCol2Data:', haveCol2Data);
  //   if (haveCol2Data) {
  //     setShowSecondCol(true);
  //   }
  // }, [haveCol2Data])

  const onBackClick = () => {
    dispatch(setActiveTool(null));
  }

  const ContentHead = () => {
    const contentTitle = titleText;
    const isDark = Utils.IsDarkTheme();

    return (
      <div className="d-flex align-items-center " style={{ borderBottom: "dashed gray 1px" }}>
        <div className="flex-shrink-0 d-block show-md-bellow me-2">
          <Link
            to="#"
            onClick={onBackClick}
            className={classnames("user-chat-remove text-muted font-size-18 p-2", { "user-chat-remove-dark": isDark })}
          >
            <i className="bx bx-chevron-left align-middle"></i>
          </Link>
        </div>

        <div className="flex-grow-1 overflow-hidden ">
          <div className="d-flex align-items-center">
            <div
              className={classnames("flex-shrink-0", "chat-user-img", "align-self-center", "me-0", "ms-0", "hide-md-bellow",)}
            >
              <i className={"text-muted me-3 fz-15 " + titleIcon}></i>
            </div>
            <div className="flex-grow-1 overflow-hidden">
              <h6 className="text-truncate mb-0 font-size-18">
                <Link to="#" className="user-profile-show text-reset" dangerouslySetInnerHTML={{ __html: contentTitle }}>
                </Link>
                {(titleHelp ?? []).length > 0 && (
                  <HelpInfo infos={titleHelp ?? []} />
                )}
              </h6>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="chat-content d-md-flex mpage-1col-ctn">
      <div className="w-100 overflow-hidden position-relative">
        <div className="d-flex justify-content-between ps-3 pt-3 pr-3">
          <ContentHead />
        </div>


        <div className="ps-2 pe-2">
          <div className={classnames("mpage-1col-list", { "mpage-2col-list-hide": false })}>
            {componentCol1}
          </div>
        </div>



      </div>
    </div>

  );
}

export default MasterPage1Column;